export const getCellType = (cellValue: any) => {
  const parsedType = typeof cellValue;
  const numberRegex = /^-?\d+(\.\d+)?$/;

  return {
    isBoolean:
      parsedType === "boolean" ||
      (parsedType === "string" &&
        ["true", "false"].includes(cellValue?.toLowerCase())),
    isNumber:
      parsedType === "number" ||
      (parsedType === "string" &&
        !isNaN(parseFloat(cellValue)) &&
        numberRegex.test(cellValue)),
  };
};
